import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { SubmitButton } from '../components/Buttons';
import { TextFormField } from '../components/FormFields';
import Message from '../components/Message';
import { Context } from '../components/Store';
import {
  createStockage,
  editStockage,
  getStockage,
} from '../functions/stockage';

export default function StockageForm(props) {
  const [state] = useContext(Context);
  const history = useHistory();
  const [stockage, setStockage] = useState('');
  const [mode, setMode] = useState('create');
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [warning, setWarning] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const fetchStockage = useCallback(async () => {
    setInfo('');
    setError('');
    setWarning('');
    setIsLoading(true);
    const FetchedStockage = await getStockage(
      props.match.params.id,
      state.token
    );
    setIsLoading(false);
    if (FetchedStockage.error) return setError(FetchedStockage.error);
    setStockage(FetchedStockage.data?.nom);
    document.title =
      FetchedStockage.data?.nom || "Mise à jour d'une zone de stockage";
    document.getElementById('big-title').innerText =
      FetchedStockage.data?.nom || "Mise à jour d'une zone de stockage";
  }, [state.token, props.match.params.id]);

  useEffect(() => {
    if (props.match.params.id) {
      setMode('update');
      fetchStockage();
    } else document.title = 'Nouvelle zone de stockage';
  }, [fetchStockage, props.match.params.id]);

  const submitForm = async () => {
    setError('');
    setWarning('');
    setInfo('');
    if (stockage.length === 0)
      return setWarning('Le nom de la zone doit être renseigné.');
    setIsLoading(true);
    const newStockage =
      mode === 'create'
        ? await createStockage({ nom: stockage }, state.token)
        : await editStockage(
            props.match.params.id,
            { nom: stockage },
            state.token
          );
    setIsLoading(false);
    if (newStockage.error) return setError(newStockage.error);
    if (mode === 'create')
      localStorage.setItem(
        'message',
        `La zone de stockage ${stockage} a bien été créée.`
      );
    else
      localStorage.setItem(
        'message',
        `La zone de stockage ${stockage} a bien été modifiée.`
      );
    return history.push(`/stockages`);
  };

  return (
    <div className="flex flex-col items-center">
      <div className="w-full lg:w-11/12 mb-10">
        <h1
          className="mt-6 text-2xl sm:text-3xl md:text-4xl uppercase font-bold mb-8"
          id="big-title"
        >
          {mode === 'create'
            ? 'Nouvelle zone de stockage'
            : "Mise à jour d'une zone de stockage"}
        </h1>
        {error ? <Message message={error} setError={setError} /> : null}
        {warning ? (
          <Message message={warning} type="warning" setError={setWarning} />
        ) : null}
        {info ? (
          <Message message={info} type="success" setError={setInfo} />
        ) : null}
        {isLoading ? (
          'Chargement...'
        ) : (props.match.params.id && stockage.length > 0) ||
          !props.match.params.id ? (
          <div className="bg-viguierBleu rounded">
            <div className="bg-viguierBleu text-white rounded-t">
              <div className="flex items-center justify-center py-2 font-bold">
                <div className="flex w-1/3 justify-center">
                  <h2>
                    {mode === 'create'
                      ? 'Créer une zone de stockage'
                      : 'Modifier une zone de stockage'}
                  </h2>
                </div>
              </div>
            </div>
            <div className="bg-viguierBleu">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  submitForm();
                }}
                className="px-4 py-3 text-white font-bold grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-2 border-4 border-white bg-viguierBleuClair mt-5 mb-5 ml-5 mr-5 rounded-md"
              >
                <TextFormField
                  value={stockage}
                  setter={setStockage}
                  label="Nom de la zone"
                  id="stockage"
                />
              </form>
            </div>
            <div className="bg-viguierBleu text-white justify-between flex rounded-b px-4 py-2">
              <SubmitButton
                action={() => history.push('/stockages')}
                label="Revenir à la liste"
              />
              <SubmitButton
                action={submitForm}
                label={
                  mode === 'create'
                    ? 'Créer une nouvelle zone'
                    : 'Modifier la zone'
                }
              />
            </div>
          </div>
        ) : (
          <div>
            <Message
              message={`La zone de stockage ${props.match.params.id} n'a été trouvée`}
              type="warning"
              setError={setWarning}
            />
            <div className="mt-10 mb-5 text-stbMain font-semibold">
              <span
                onClick={fetchStockage}
                className="cursor-pointer border-2 border-stbMain rounded-md p-1"
              >
                Réessayer
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
